import { useState } from 'react';
import { configService } from '../services/configService';
import { validatePostalCode } from '../utils/formValidation';
import { PREFECTURES } from '../data/prefectures';

/**
 * 郵便番号から住所を自動検索するカスタムフック
 * @param {Function} onSuccess - 住所取得成功時のコールバック({ prefecture, city, address })
 * @returns {{ postalMessage: string, isSuccess: boolean, searchAddress: Function }}
 */
const useAddressSearch = (onSuccess) => {
  const [postalMessage, setPostalMessage] = useState('');
  const [isSuccess, setIsSuccess] = useState(false);

  const searchAddress = async (postalCode) => {
    const validationError = validatePostalCode(postalCode);
    if (validationError) {
      setPostalMessage(validationError);
      setIsSuccess(false);
      return;
    }

    setPostalMessage('検索中...');
    setIsSuccess(false);

    try {
      const postalApiUrl = configService.getConfig('postalCodeApiUrl');
      if (!postalApiUrl) throw new Error('郵便番号APIが設定されていません');

      const response = await fetch(`${postalApiUrl}?zipcode=${postalCode}`);
      const data = await response.json();

      if (data.status === 200 && data.results?.length > 0) {
        const { address1, address2, address3 } = data.results[0];
        const matched = PREFECTURES.find(p => p.label === address1);
        onSuccess({
          prefectureLabel: address1,
          prefectureCode: matched ? matched.value : '',
          city: address2,
          address: address3
        });
        setPostalMessage('住所を取得しました');
        setIsSuccess(true);
      } else {
        setPostalMessage('住所が見つかりませんでした');
        setIsSuccess(false);
      }
    } catch (error) {
      console.error('[useAddressSearch] 郵便番号検索エラー:', error);
      setPostalMessage('住所の取得に失敗しました');
      setIsSuccess(false);
    }
  };

  return { postalMessage, isSuccess, searchAddress };
};

export default useAddressSearch;